import {
    AppBar,
    Button,
    Card,
    CardContent,
    CardHeader,
    Container,
    MenuItem,
    TextField,
    Toolbar,
    Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { getHouseholdById } from '../../../actions/households/households.actions'
import { showError, showSuccess } from '../../../actions/misc/misc.actions'
import { addPet } from '../../../actions/pets/pets.actions'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '20px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))'
	},
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '424px !important',
			margin: 0
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	}
}))

const Add = (props) => {
	const classes = useStyles()
	const params = useParams()
	const history = useHistory()
	const dispatch = useDispatch()

	const client = useSelector((state) => state.specific.households.selected)
	const loading = useSelector((state) => state.specific.households.loading)
	const error = useSelector((state) => state.specific.households.error)

	const [pet, setPet] = useState({})
	const [isOpen, setIsOpen] = useState(false)
	const [hasFormError, setHasFormError] = useState(false)

	const sexes = ['Intact Male', 'Neutered Male', 'Intact Female', 'Spayed Female', 'Unknown']

	useEffect(() => {
		if (error) {
			dispatch(showError(error))
		}
	}, [error])

	const createPet = () => {
		if (!pet.name) {
			setHasFormError(true)
			return dispatch(showError('Fix form errors.'))
		}

		dispatch(addPet(client._id, pet)).then(() => {
			if (!error) {
				dispatch(getHouseholdById(client._id))
				dispatch(showSuccess(`${pet.name} created!`))
				goToPetsPage()
			}
		})
	}

	const goToPetsPage = () => {
		if (client) {
			history.push(`/clients/${client._id}/pets`)
		}
	}

	return (
		<Container className={classes.root} maxWidth="md">
			<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
				New Pet
			</Typography>
			<Card>
				<CardHeader title="General Info" />
				<CardContent>
					<div className={classes.grid}>
						<div className={classes.fieldWrapper}>
							<TextField
								label="Name *"
								variant="filled"
								value={pet.name || ''}
								onChange={(e) => setPet({ ...pet, name: e.target.value })}
								error={hasFormError}
								helperText={hasFormError ? 'Name is required.' : null}
							/>
						</div>
						<div className={classes.fieldWrapper}>
							<KeyboardDatePicker
								open={isOpen}
								onOpen={() => setIsOpen(true)}
								onClose={() => setIsOpen(false)}
								variant="inline"
								format="MM/DD/YYYY"
								margin="normal"
								id="pet-birthday"
								label="Birthday"
								inputVariant="filled"
								value={pet.birthday || null}
								onChange={(date) => setPet({ ...pet, birthday: date })}
								className={classes.datePicker}
								rightArrowIcon={
									<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
								}
								leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
								KeyboardButtonProps={{
									'aria-label': 'Birthday',
									className: classes.calendarButton
								}}
							/>
						</div>
						<div className={classes.fieldWrapper}>
							<TextField
								label="Sex"
								variant="filled"
								select
								value={pet.sex}
								onChange={(e) => setPet({ ...pet, sex: e.target.value })}>
								{sexes.map((sex) => (
									<MenuItem key={sex} value={sex}>
										{sex}
									</MenuItem>
								))}
							</TextField>
						</div>
						<div className={classes.fieldWrapper}>
							<TextField
								label="Animal Type"
								variant="filled"
								select
								value={pet.animal_type || ''}
								onChange={(e) => setPet({ ...pet, animal_type: e.target.value })}>
								<MenuItem value={'Dog'}>Dog</MenuItem>
								<MenuItem value={'Cat'}>Cat</MenuItem>
							</TextField>
						</div>
					</div>
				</CardContent>
			</Card>
			<AppBar position="fixed" color="primary" className={classes.appBar}>
				<Toolbar>
					<Container maxWidth="md">
						<Button
							variant="contained"
							color="secondary"
							style={{ marginRight: '8px' }}
							onClick={() => createPet()}>
							Add Pet
						</Button>
						<Button variant="outlined" color="secondary" onClick={goToPetsPage}>
							Cancel
						</Button>
					</Container>
				</Toolbar>
			</AppBar>
			{loading ? <LoadingOverlay /> : null}
		</Container>
	)
}

export default Add
